import React, { useState } from "react";
import styles from "./style.module.css";

export interface FilterOption {
  label: string;
  count: number;
}

export interface FilterCategory {
  title: string;
  options: FilterOption[];
}

interface FilterDropdownProps {
  categories: FilterCategory[];
  defaultExpanded?: string;
  defaultSelected?: string[];
  classname?: string;
  onChange?: (selected: string[]) => void;
}

export const FilterDropdown: React.FC<FilterDropdownProps> = ({
  categories,
  defaultExpanded,
  defaultSelected = [],
  classname,
  onChange,
}) => {
  const [expanded, setExpanded] = useState<string | undefined>(
    defaultExpanded
  );
  const [selected, setSelected] = useState<{ [key: string]: boolean }>(
    Object.fromEntries(defaultSelected.map((opt) => [opt, true]))
  );

  const toggleCategory = (title: string) => {
    setExpanded(expanded === title ? "" : title);
  };

  const toggleOption = (label: string) => {
    setSelected((prev) => {
      const updated = { ...prev, [label]: !prev[label] };
      if (onChange) {
        const selectedValues = Object.keys(updated).filter((k) => updated[k]);
        onChange(selectedValues);
      }
      return updated;
    });
  };

  return (
    <div className={`${styles.dropdown} ${classname ?? ""}`}>
      {categories.map((category) => (
        <div key={category.title}>
          <button
            className={styles.categoryHeader}
            onClick={() => toggleCategory(category.title)}
          >
            <span>{category.title}</span>
            <span
              className={`${styles.arrow} ${
                expanded === category.title ? styles.arrowDown : ""
              }`}
            />
          </button>

          {expanded === category.title && (
            <div className={styles.options}>
              {category.options.map((option) => (
                <label key={option.label} className={styles.optionLabel}>
                  <input
                    type="checkbox"
                    checked={!!selected[option.label]}
                    onChange={() => toggleOption(option.label)}
                    className={styles.checkbox}
                  />
                  <span>
                    {option.label} ({option.count})
                  </span>
                </label>
              ))}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};